export const RIBBON_TAB_FONT_SIZE = "13px";
export const RIBBON_TAB_FONT_WEIGHT = 400;
export const RIBBON_TAB_LINE_HEIGHT = "28px";
export const RIBBON_TAB_MIN_HEIGHT = "30px";
export const RIBBON_TAB_HORIZONTAL_PADDING = "8px";
